"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopAreaReservedSpaceBlock = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
var _getMobileCssVariable = require("../../utils/getMobileCssVariable");
const TopAreaReservedSpaceBlock = exports.TopAreaReservedSpaceBlock = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  isTopBannerVisible,
  isTopNavigationVisible,
  showSearchOnScroll,
  theme
}) => ({
  minHeight: (0, _getMobileCssVariable.getMobileCssHeightVariable)({
    isTopBannerVisible,
    showSearchOnScroll
  }),
  [theme.breakpoints.up('md')]: {
    minHeight: (0, _getMobileCssVariable.getDesktopCssHeightVariable)({
      isTopBannerVisible,
      isTopNavigationVisible
    })
  }
}));
